var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHistoryVendingTransaction(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 12.9006C5.625 12.9006 5.625 6.68753 5.625 4.78867C5.625 4.34707 5.80043 3.92372 6.11348 3.61172C6.42587 3.29972 6.84978 3.125 7.29196 3.125C9.93458 3.125 15.4164 3.125 15.4164 3.125",
    stroke: "currentColor",
    strokeOpacity: 0.8,
    strokeWidth: 1.25,
    strokeMiterlimit: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0833 16.8743H4.81908C4.36973 16.8743 3.93882 16.6959 3.62105 16.3783C3.30329 16.0606 3.125 15.6297 3.125 15.1806C3.125 15.058 3.125 14.9263 3.125 14.7911C3.125 13.8706 3.87156 13.1243 4.79203 13.1243C6.3822 13.1243 7.78447 13.1243 9.37467 13.1243C10.2951 13.1243 11.0417 13.8705 11.0417 14.791V15.2093C11.0417 16.1285 11.7875 16.8743 12.7067 16.8743H12.71C13.6292 16.8743 14.375 16.1285 14.375 15.2093V7.91602",
    stroke: "currentColor",
    strokeOpacity: 0.8,
    strokeWidth: 1.25,
    strokeMiterlimit: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0417 3.125C16.9494 3.125 17.7083 3.8839 17.7083 4.79167C17.7083 5.17194 17.7083 5.61626 17.7083 6.04179C17.7083 6.96227 16.9622 7.70833 16.0417 7.70833H14.375V4.79167C14.375 4.34962 14.5507 3.92577 14.8631 3.61321C15.1756 3.30064 15.5997 3.125 16.0417 3.125Z",
    stroke: "currentColor",
    strokeOpacity: 0.8,
    strokeWidth: 1.25,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryVendingTransaction);
export default __webpack_public_path__ + "static/media/history_vending_transaction.ab3f96a57e34fe8926ffab72935cab26.svg";
export { ForwardRef as ReactComponent };